import React from 'react';
import { Row, Col, Glyphicon, Button } from 'react-bootstrap'
import AuditDetail from 'areas/shared/components/audit/AuditDetail';
import * as Formatting from 'fw/misc/Formatting'

class AuditItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        }
    }

    toggle = () => {
        this.setState(
            { expanded: !this.state.expanded }
        );
    }

    render() {
        const item = this.props.item;

        let details = null;

        if (this.state.expanded) {
            details = (
                <span style={{ marginLeft: "40px" }} >
                    No additional information<br /><br />
                </span >);

            if (item.changeList.length > 0) {
                details = (
                    <React.Fragment>
                        <AuditDetail changeList={item.changeList} />
                        <br />
                    </React.Fragment>);
            }
        }

        return (
            <React.Fragment>
                <Row>
                    <Col md={2} style={{
                        paddingRight: "0px",
                        paddingLeft: "10px"
                    }}>
                        <Button bsStyle="link" className="log-toggle" onClick={this.toggle}>
                            <Glyphicon glyph="play" />
                            <span className="log" style={{ marginLeft: '5px' }}>{Formatting.formatClientDateTime(item.date)}</span>
                        </Button>
                    </Col>
                    <Col md={2}>
                        <span className="log">{item.userName}</span>
                    </Col>
                    <Col md={2}>
                        <span className="log">{item.actionName}</span>
                    </Col>
                    <Col md={6}>
                        <span className="log">
                            {item.description}
                            {item.comments ?
                                <div>
                                    <em><b>Comments:</b> {item.comments}</em>
                                    <br />
                                </div>
                            :null}
                        </span>
                    </Col>
                </Row>
                {details}
                <hr />
            </React.Fragment>
        );
    }
}
export default AuditItem;



// WEBPACK FOOTER //
// ./src/areas/admin/auditReview/AuditItem.js